module.exports = __webpack_public_path__ + "static/img/img_zongheti.2dae000.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/img_zongheti.png
// module id = UKZR
// module chunks = 1